var n=function(n){return null!=n?n:""};export{n as emptyByDefault};
//# sourceMappingURL=emptyByDefault.js.map
